export const environments = {
  LOCAL: 'local',
  DES: 'des',
  PRE: 'pre',
  PRO: 'pro',
  PRO_CN_CPD1: 'pro_cn_cpd1',
  PRO_CN_CPD2: 'pro_cn_cpd2'
}

export const getBaseUrls = (enviroment) => {
  switch (enviroment) {
    case environments.LOCAL:
      return getBaseUrlsLocal
    case environments.DES:
      return getBaseUrlsDES
    case environments.PRE:
      return getBaseUrlsPRE
    case environments.PRO:
      return getBaseUrlsPRO
    case environments.PRO_CN_CPD1:
      return getBaseUrlsPROCNCpd1
    case environments.PRO_CN_CPD2:
      return getBaseUrlsPROCNCpd2
    default:
      return getBaseUrlsLocal
  }
}

export const getPrivateBaseUrls = (enviroment) => {
  switch (enviroment) {
    case environments.LOCAL:
      return getPrivateBaseUrlsLocal
    case environments.DES:
      return getPrivateBaseUrlsDES
    case environments.PRE:
      return getPrivateBaseUrlsPRE
    case environments.PRO:
      return getPrivateBaseUrlsPRO
    case environments.PRO_CN_CPD1:
      return getPrivateBaseUrlsPROCNCpd1
    case environments.PRO_CN_CPD2:
      return getPrivateBaseUrlsPROCNCpd2
    default:
      return getBaseUrlsLocal
  }
}

const getBaseUrlsLocal = {
  Oysho: 'http://localhost:8080/gema'
}
const getBaseUrlsDES = {
  Oysho: 'https://des-mecgemabkt-productandcatalog.oy.apps.axdesecocp1.ecommerce.inditex.grp/mecgemabkt'
}
const getBaseUrlsPRE = {
  Dutti: 'https://pre-gema.md.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-md',
  Oysho: 'https://pre-gema.oy.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://pre-gema.bk.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://pre-gema.st.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://pre-gema.zh.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-zh',
  Pull: 'https://pre-gema.pb.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-pb',
  Zara: 'https://pre-gema.za.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-za'
}
const getBaseUrlsPRO = {
  Dutti: 'https://gema-md.axinocp1.central.inditex.grp/mecgemabkt-md',
  Oysho: 'https://gema-oy.axinocp1.central.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://gema-bk.axinocp1.central.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://gema-st.axinocp1.central.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://gema-zh.axinocp1.central.inditex.grp/mecgemabkt-zh',
  Pull: 'https://gema-pb.axinocp1.central.inditex.grp/mecgemabkt-pb',
  Zara: 'https://gema-za.axinocp1.central.inditex.grp/mecgemabkt-za'
}

const getBaseUrlsPROCNCpd1 = {
  Dutti: 'https://gema.md.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-md',
  Oysho: 'https://gema.oy.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://gema.bk.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://gema.st.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://gema.zh.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-zh',
  Pull: 'https://gema.pb.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-pb',
  Zara: 'https://gema.za.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-za'
}

const getBaseUrlsPROCNCpd2 = {
  Dutti: 'https://gema.md.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-md',
  Oysho: 'https://gema.oy.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://gema.bk.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://gema.st.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://gema.zh.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-zh',
  Pull: 'https://gema.pb.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-pb',
  Zara: 'https://gema.za.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-za'
}

const getPrivateBaseUrlsLocal = {
  Oysho: 'http://localhost:8080/gema'
}
const getPrivateBaseUrlsDES = {
  Oysho: 'https://des-mecgemabkt-productandcatalog-private.oy.apps.axdesecocp1.ecommerce.inditex.grp/mecgemabkt'
}
const getPrivateBaseUrlsPRE = {
  Dutti: 'https://pre-mecgemabkt-productandcatalog-private.md.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-md',
  Oysho: 'https://pre-mecgemabkt-productandcatalog-private.oy.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://pre-mecgemabkt-productandcatalog-private.bk.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://pre-mecgemabkt-productandcatalog-private.st.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://pre-mecgemabkt-productandcatalog-private.zh.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-zh',
  Pull: 'https://pre-mecgemabkt-productandcatalog-private.pb.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-pb',
  Zara: 'https://pre-mecgemabkt-productandcatalog-private.za.apps.axpreecocp2.ecommerce.inditex.grp/mecgemabkt-za'
}

const getPrivateBaseUrlsPRO = {
  Dutti: 'https://mecgemabkt-productandcatalog-md-private.axinocp1.central.inditex.grp/mecgemabkt-md',
  Oysho: 'https://mecgemabkt-productandcatalog-oy-private.axinocp1.central.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://mecgemabkt-productandcatalog-bk-private.axinocp1.central.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://mecgemabkt-productandcatalog-st-private.axinocp1.central.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://mecgemabkt-productandcatalog-zh-private.axinocp1.central.inditex.grp/mecgemabkt-zh',
  Pull: 'https://mecgemabkt-productandcatalog-pb-private.axinocp1.central.inditex.grp/mecgemabkt-pb',
  Zara: 'https://mecgemabkt-productandcatalog-za-private.axinocp1.central.inditex.grp/mecgemabkt-za'
}

const getPrivateBaseUrlsPROCNCpd1 = {
  Dutti: 'https://mecgemabkt-productandcatalog-private.md.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-md',
  Oysho: 'https://mecgemabkt-productandcatalog-private.oy.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://mecgemabkt-productandcatalog-private.bk.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://mecgemabkt-productandcatalog-private.st.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://mecgemabkt-productandcatalog-private.zh.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-zh',
  Pull: 'https://mecgemabkt-productandcatalog-private.pb.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-pb',
  Zara: 'https://mecgemabkt-productandcatalog-private.za.apps.cnec1ocp1.ecommerce.inditex.grp/mecgemabkt-za'
}

const getPrivateBaseUrlsPROCNCpd2 = {
  Dutti: 'https://mecgemabkt-productandcatalog-private.md.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-md',
  Oysho: 'https://mecgemabkt-productandcatalog-private.oy.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-oy',
  Berhska: 'https://mecgemabkt-productandcatalog-private.bk.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-bk',
  Stradivarius: 'https://mecgemabkt-productandcatalog-private.st.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-st',
  ZaraHome: 'https://mecgemabkt-productandcatalog-private.zh.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-zh',
  Pull: 'https://mecgemabkt-productandcatalog-private.pb.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-pb',
  Zara: 'https://mecgemabkt-productandcatalog-private.za.apps.cnec2ocp1.ecommerce.inditex.grp/mecgemabkt-za'
}
